"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var InputBase_1 = require("./InputBase");
var FormControl_1 = require("../FormControl");
var Error_1 = require("../Error");
exports.Input = function (_a) {
    var as = _a.as, error = _a.error, backgroundColor = _a.backgroundColor, rest = tslib_1.__rest(_a, ["as", "error", "backgroundColor"]);
    var hasError = !!error;
    return (react_1.default.createElement(FormControl_1.FormControl, null,
        react_1.default.createElement(InputBase_1.InputBase, tslib_1.__assign({}, rest, { inputComponent: as, error: hasError, backgroundColor: backgroundColor })),
        react_1.default.createElement(Error_1.Error, { isVisible: hasError }, error)));
};
exports.Input.displayName = 'FOS_Input';
